import * as React from 'react';

export interface IModalWindowFooterProps {
  mode?: modalWindowMode;
  children?: React.ReactNode;
  onClose?: () => void;
}

export type modalWindowMode = 'default' | 'transition';

export const ModalWindowFooter: React.FC<IModalWindowFooterProps> = (props) => {
  return <>{props.children}</>;
};
